
import ConstService from 'pk/service/ConstService'
import { defineComponent } from 'vue'
import IOService from 'pk/service/IOService'
import FormMixins from './FormMixins'

export default defineComponent({
  mixins: [FormMixins],
  props: {
    type: String,
    url: String
  },
  data () {
    return {
      paths: [] as number[][] | string[][],
      props: {
        expandTrigger: 'hover',
        label: 'display_name',
        value: 'id',
        multiple: true,
        emitPath: false
      },
      innerUrl: this.url
    }
  },
  created () {
    this.setInnerValue()
    this.handleLoad()
      .then(() => {
        Object.assign(this.props, this.field.props)
      })
  },
  methods: {
    setInnerValue () {
      this.innerValue = (this.modelValue as any || []).map((res: number | { id: number }) => {
        if (typeof res === 'object' && res.id) {
          return res.id
        } else {
          return res
        }
      })
    },
    handleLoad () {
      return Promise.resolve()
        .then(() => {
          if (this.type === 'industry') {
            this.innerUrl = '/industry'
          }
          if (this.type === 'city') {
            this.field.props = {
              label: 'name',
              value: 'id'
            }
            return ConstService.getAreaOptions()
          } else if (this.innerUrl) {
            return IOService.get(this.innerUrl)
              .then((res) => res.data || [])
          }
        })
        .then((data) => {
          this.field.options = data
        })
    },
    handleChange () {
      this.$nextTick(() => {
        this.formService.validateField(this.field.prop)
      })
    }
  }
})
